import { isMobile } from '@/utils/utils';
import { atom, useRecoilState } from 'recoil';

export enum AppBannerType {
    None = 'none',
    CreditsFinishing = 'credits-finishing',
    AccountNotPrimary = 'account-not-primary',
    Marketing = 'marketing',
    NewEditor = 'new-editor',
    CreditsMigration = 'credit-migration',
    Agents = 'agents',
    PaymentUnsuccessfulBanner = 'payment-unsuccessful-banner',
}

export const _appBanner = atom<AppBannerType>({
    key: 'app-banner',
    default: AppBannerType.None,
});

export const useAppBanner = () => {
    const [appBanner, setAppBanner] = useRecoilState(_appBanner);
    const isMobileDevice = isMobile();

    const dismissedBanners: Record<AppBannerType, boolean> = {
        [AppBannerType.None]: false,
        [AppBannerType.CreditsFinishing]: false,
        [AppBannerType.AccountNotPrimary]: false,
        [AppBannerType.Marketing]: false,
        [AppBannerType.NewEditor]: false,
        [AppBannerType.CreditsMigration]: false,
        [AppBannerType.Agents]: false,
        [AppBannerType.PaymentUnsuccessfulBanner]: false,
    };

    const closeAppBanner = () => {
        setAppBanner(AppBannerType.None);
        dismissedBanners[appBanner] = true;
    };

    const openAppBanner = (args: { type: AppBannerType }) => {
        dismissedBanners[args.type] = false;
        setAppBanner(args.type);
    };

    const isOpen = appBanner !== AppBannerType.None && !dismissedBanners[appBanner] && !isMobileDevice;

    return {
        type: appBanner,
        close: closeAppBanner,
        isOpen,
        open: openAppBanner,
    };
};
